import PaidIcon from "@mui/icons-material/Paid";
import { resources as BankTransfers } from "./BankTransfers";
import { resources as OnlinePayments } from "./OnlinePayments";
import { resources as CashPayments } from "./CashPayments";
import { resources as PaymentExpectations } from "./PaymentExpectations";
import { resources as Ibans } from "./Ibans";
import { resources as Obligations } from "./Obligations";
import { resources as Deposits } from "./Deposits";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <PaidIcon />,
  name: "Паричен поток",
  title: "Паричен поток",
  subMenu: [BankTransfers, OnlinePayments, CashPayments, PaymentExpectations, Ibans, Obligations, Deposits],
};
